import axios from 'axios';

import { CSRF_TOKEN } from '@shared/config/csrf';

import type { ISubscription } from '@admin/types/subscription';

export interface AccountShowCoupon {
  name?: string;
  percent?: number;
  amount?: number;
}

export interface AccountShowRecord {
  id: number | string;
  number: string;
  stripe_id?: string;
  state: string;
  delinquent_reason?: string;
  tags?: string[];
  cardless?: boolean;
  partner_managed?: boolean;
  third_party_logistics?: boolean;
  onboarding_confirmed?: boolean | null;
  is_cancelable?: boolean;
  is_unsuspendable?: boolean;
  is_suspendable?: boolean;
  billing_date_changeable?: boolean;
  billing_date_changed_on: string | null;
  subscription_billing_day: number;
  coupon?: AccountShowCoupon;
  customers?: Array<{ name: string; phones?: { primary?: boolean }[] }>;
  customer: { id: string; name: string };
  subscriptions?: ISubscription[];
}

export const unsuspendAccount = async (accountID: number | string) => {
  await axios.put(
    `/accounts/${accountID}/unsuspend.json`,
    {},
    {
      headers: {
        'X-CSRF-Token': CSRF_TOKEN ?? '',
      },
    },
  );
};

export const notifyAccountInvoicesRefresh = () => {
  document.dispatchEvent(new CustomEvent('admin:account-invoices-refresh'));
};

export const requestAccountShowRefresh = () => {
  document.dispatchEvent(new CustomEvent('admin:accounts-show-refresh'));
};
